document.addEventListener('DOMContentLoaded', function() {
  // Function to check if an element is in the viewport
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const triggerPoint = viewportHeight * 0.75;
    return rect.top <= triggerPoint;
  }

  // Function to remove a class when elements enter the viewport
  function removeClassOnViewport() {
    const elements = document.querySelectorAll('.anim-slide-in, .anim-slide-in-children');
    elements.forEach(function(element) {
      if (isInViewport(element)) {
        element.classList.add('animated');
      }
    });
  }

  // Check on scroll and resize
  window.addEventListener('scroll', removeClassOnViewport);
  window.addEventListener('resize', removeClassOnViewport);

  // Initial check
  removeClassOnViewport();
});
